import { render } from "./DocumentsView.vue?vue&type=template&id=d756ea8e&scoped=true&ts=true&lang=pug"
import script from "./DocumentsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentsView.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentsView.vue?vue&type=style&index=0&id=d756ea8e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d756ea8e"]])

export default __exports__